"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ApiKeyListComponent = _interopRequireDefault(require("./ApiKeyListComponent"));
var _modalActions = require("../../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var apiKeys = state.apiKey.apiKeys;
  return {
    apiKeys: apiKeys
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    removeApiKey: function removeApiKey(apiKey) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.REMOVE_API_KEY, {
        apiKey: apiKey
      }));
    },
    editApiKeyWhitelistIpAddresses: function editApiKeyWhitelistIpAddresses(payload) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.EDIT_API_KEY_WHITELIST_IP_ADDRESS, {
        payload: payload
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ApiKeyListComponent["default"]);